
/// <amd-module name="VC/Pullrequest/Common/PullRequestAdornmentService" />
import { IGutterAdornmentCollection } from 'VC/Pullrequest/Common/GutterAdornments'

/** Interface which extension writer needs to implement for it to be recognized by PR page. */
export interface IPullRequestAdornmentService {
    
    /** Gets extension friendly name. */
    getExtensionName(): Promise<string>;

    /** Initialize the extension. */
    initializeExtension(pullRequestContext: IPullRequestContext): void;

    /** Gets gutter adornments for corresponding pull request context. */
    getGutterAdornments(pullRequestFileContext: IPullRequestFileContext): Promise<IGutterAdornmentCollection>;
}

/**  Passed to Extension writer. This is context of Pull request to initialize extensions. */
export interface IPullRequestContext {

    /** AzureDevops account name. */
    organisationName: string;

    /** AzureDevops project ID. */
    projectId: string;

    /** Pull request Id. */
    pullRequestId: number;

    /** Repository Id. */
    repositoryId: string;
}

/**  Passed to Extension writer. This one has file context for which adornments needs to be fetched. */
export interface IPullRequestFileContext {

    /** Pull request Iteration Id. */
    iterationId: number;

    /** Pull request base Iteration Id. */
    baseIterationId: number;

    /** Modified File Path. */
    mPath: string;

    /** Original File Path. */
    oPath: string;
}
